var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 519,
    height: 1030,
    viewBox: "0 0 519 1030",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76.948 342.485L108.388 360.795L108.25 397.179L76.6722 415.251L45.2325 396.94L45.3704 360.557L76.948 342.485Z",
    fill: "#297BC7",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M111.139 184.354L136.42 199.078L136.309 228.333L110.918 242.864L85.6374 228.141L85.7483 198.886L111.139 184.354Z",
    fill: "#297BC7",
    fillOpacity: 0.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M275.685 10.3673L294.427 21.2826L294.345 42.9706L275.521 53.7435L256.78 42.8283L256.862 21.1402L275.685 10.3673Z",
    fill: "#297BC7",
    fillOpacity: 0.1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M364.355 112.417L382.65 123.073L382.57 144.244L364.194 154.761L345.899 144.105L345.979 122.934L364.355 112.417Z",
    fill: "#297BC7",
    fillOpacity: 0.1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M181.977 75.7748L202.765 87.8819L202.674 111.938L181.795 123.888L161.007 111.78L161.098 87.724L181.977 75.7748Z",
    fill: "#297BC7",
    fillOpacity: 0.1
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0757 489.85L76.3033 510.367L76.1488 551.134L40.7667 571.383L5.53897 550.866L5.69346 510.099L41.0757 489.85Z",
    fill: "#297BC7",
    fillOpacity: 0.1
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M455.488 619.295L501.254 645.95L501.053 698.911L455.087 725.218L409.322 698.564L409.522 645.602L455.488 619.295Z",
    fill: "#297BC7",
    fillOpacity: 0.1
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M462.41 897.92L511.311 926.4L511.097 982.991L461.981 1011.1L413.079 982.619L413.294 926.029L462.41 897.92Z",
    fill: "#297BC7",
    fillOpacity: 0.1
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M87.3299 870.239L156.188 910.343L155.886 990.028L86.7259 1029.61L17.8682 989.505L18.1702 909.82L87.3299 870.239Z",
    fill: "#297BC7",
    fillOpacity: 0.1
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M306.53 767.069L355.466 795.57L355.251 852.2L306.101 880.33L257.165 851.829L257.379 795.198L306.53 767.069Z",
    fill: "#297BC7",
    fillOpacity: 0.1
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9629 722.635L87.0387 743.064L86.8849 783.655L51.6552 803.817L16.5795 783.388L16.7333 742.797L51.9629 722.635Z",
    fill: "#297BC7",
    fillOpacity: 0.1
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M197.142 610.623L246.3 639.253L246.084 696.139L196.711 724.396L147.554 695.766L147.769 638.879L197.142 610.623Z",
    fill: "#297BC7",
    fillOpacity: 0.1
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M439.973 478.749L467.045 494.515L466.926 525.843L439.736 541.405L412.664 525.638L412.783 494.31L439.973 478.749Z",
    fill: "#297BC7",
    fillOpacity: 0.1
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M405.292 332.655L434.54 349.689L434.411 383.536L405.035 400.348L375.787 383.313L375.916 349.467L405.292 332.655Z",
    fill: "#297BC7",
    fillOpacity: 0.1
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M347.669 195.218L368.045 207.085L367.955 230.665L347.49 242.378L327.114 230.51L327.203 206.931L347.669 195.218Z",
    fill: "#297BC7",
    fillOpacity: 0.1
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M393.699 1.01666L410.634 10.8802L410.56 30.4787L393.55 40.2136L376.614 30.35L376.689 10.7516L393.699 1.01666Z",
    fill: "#297BC7",
    fillOpacity: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground);
export default __webpack_public_path__ + "static/media/background.8796890fb71f84fa63621122ba9ddd1d.svg";
export { ForwardRef as ReactComponent };